import { useSelector } from 'react-redux'
import { SCREEN } from '../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../common/selectCurrencyUnit/useFormatCurrency'

export const AmountCell = ({ rowId, getDataFromRedux, data }) => {
  const rowData = useSelector(getDataFromRedux(rowId))

  const { formatCurrency } = useFormatCurrency(SCREEN.FILING_STATUS)

  const year = new Date(rowData.publicDateId).getFullYear()

  return formatCurrency({ value: data, year })
}
